import { Signal } from "./Signal.js";
import { Slot } from "./Slot.js";

export class SlotNextFrame<T extends any[]> extends Slot<T> {

    private _timeout: number = 0;
    private _isThrottling: boolean = false;
    private _args: any[] = null;

    public execute(args: any[]): void {
        if (this._isThrottling) {
            this._args = args;
            return;
        }

        this._args = args;
        this.immediate();
    }

    public get isThrottling(): boolean {
        return this._isThrottling;
    }

    public immediate(): void {
        window.cancelAnimationFrame(this._timeout);
        this._timeout = null;
        if (this._args) {
            if (this.enabled) {
                this.listener.apply(this.context, this._args as any);
            }
            this._args = null;
            this._isThrottling = true;

            this._timeout = window.requestAnimationFrame(() => {
                this._isThrottling = false;
                if (this._args) {
                    this.immediate();
                }
            });
        } else {
            this._isThrottling = false;
        }
    }

    public cancel(): void {
        window.cancelAnimationFrame(this._timeout);
        this._timeout = null;
        this._args = null;
        this._isThrottling = false;
    }

    public dispose(): void {
        this.cancel();
        this._timeout = null;
        super.dispose();
    }
}